import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-save-lined",
  "use": "rt-base-save-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-save-lined\"><path d=\"M848 76H176c-55.1 0-100 44.9-100 100v672c0 55.1 44.9 100 100 100h672c55.1 0 100-44.9 100-100V176c0-55.1-44.9-100-100-100zM344 148h336v191c0 20.1-14.7 37-32 37H376c-17.3 0-32-17-32-37V148z m532 700c0 15.4-12.6 28-28 28H176c-15.4 0-28-12.6-28-28V176c0-15.4 12.6-28 28-28h104v191c0 55.7 43.1 101 96 101h272c52.9 0 96-45.3 96-101V148h104c15.4 0 28 12.6 28 28v672z\" /><path d=\"M704 640H320c-17.6 0-32 14.4-32 32s14.4 32 32 32h384c17.6 0 32-14.4 32-32s-14.4-32-32-32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/save-lined.svg
// module id = 1785
// module chunks = 137